function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useMemo, useState, useEffect } from 'react';
import { useOnClickOutside } from '@adsk/alloy-react-helpers';
import { PLACEMENTS } from '../consts';
import usePopper from './usePopper';
import useVisibility from './useVisibility';

function useOverlay(_ref) {
  var show = _ref.show,
      delayShow = _ref.delayShow,
      delayHide = _ref.delayHide,
      onHide = _ref.onHide,
      onShow = _ref.onShow,
      placement = _ref.placement,
      target = _ref.target,
      overlayRef = _ref.overlayRef,
      _ref$rootClose = _ref.rootClose,
      rootClose = _ref$rootClose === void 0 ? true : _ref$rootClose,
      offset = _ref.offset,
      layoutDependency = _ref.layoutDependency;
  var toggle = useVisibility({
    show: show,
    onHide: onHide,
    onShow: onShow,
    delayShow: delayShow,
    delayHide: delayHide
  });

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      overlayElement = _useState2[0],
      setPopperElement = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      arrowElement = _useState4[0],
      setArrowElement = _useState4[1];

  useEffect(function () {
    if (overlayElement && overlayRef) {
      overlayRef.current = overlayElement;
    }
  }, [overlayElement, overlayRef]);
  var popper = usePopper({
    placement: placement,
    show: toggle.show,
    targetElement: target === null || target === void 0 ? void 0 : target.current,
    overlayElement: overlayElement || undefined,
    arrowElement: arrowElement || undefined,
    offset: offset,
    layoutDependency: layoutDependency
  }); // Handle close on click out side

  var enableCloseOnClickOutside = rootClose && toggle.show;
  var refsToIgnore = useMemo(function () {
    return target ? [{
      current: overlayElement
    }, target] : [{
      current: overlayElement
    }];
  }, [overlayElement, target]);
  useOnClickOutside(enableCloseOnClickOutside, toggle.handleHide, refsToIgnore);
  var targetProps = useMemo(function () {
    return {
      ref: target
    };
  }, [target]);
  var overlayProps = useMemo(function () {
    return {
      ref: setPopperElement,
      style: popper.styles.overlay
    };
  }, [popper.styles.overlay]);
  var arrowProps = useMemo(function () {
    return {
      ref: setArrowElement,
      style: popper.styles.arrow
    };
  }, [popper.styles.arrow]);
  return _objectSpread(_objectSpread({}, toggle), {}, {
    placement: popper.placement,
    targetProps: targetProps,
    overlayProps: overlayProps,
    arrowProps: arrowProps
  });
}

useOverlay.PLACEMENTS = PLACEMENTS;
export default useOverlay;
//# sourceMappingURL=useOverlay.js.map